$('.cookie-overlay').on('click', (e) => {
  e.preventDefault();

  $('.ot-sdk-show-settings').click();
});
